export interface D2DRejectionMetadata {
  status?: string | null;
  lastChangedBy?: string | null;
  rejectionType?: string | null;
  rejectionTrigger?: string | null;
}

const normalizeToken = (value: string | null | undefined): string =>
  (value ?? "")
    .trim()
    .toUpperCase()
    .replace(/[\s-]+/g, "_");

const isAutoRejectToken = (value: string | null | undefined): boolean => {
  const normalized = normalizeToken(value);
  return (
    normalized === "AUTO" ||
    normalized === "AUTO_REJECT" ||
    normalized === "AUTOREJECT" ||
    normalized === "SYSTEM" ||
    normalized === "D2D_CLAIMED" ||
    normalized === "D2DCLAIMED" ||
    normalized === "CLAIMED"
  );
};

export const getD2DRejectStatusLabelKey = (
  metadata: D2DRejectionMetadata
): "d2d:status.d2dClaimed" | "d2d:status.manualRejected" | undefined => {
  if (normalizeToken(metadata.status) !== "REJECTED") {
    return undefined;
  }

  if (normalizeToken(metadata.rejectionType) === "AUTO") {
    return "d2d:status.d2dClaimed";
  }
  if (normalizeToken(metadata.rejectionType) === "MAN") {
    return "d2d:status.manualRejected";
  }
  if (
    isAutoRejectToken(metadata.rejectionType) ||
    isAutoRejectToken(metadata.rejectionTrigger) ||
    isAutoRejectToken(metadata.lastChangedBy)
  ) {
    return "d2d:status.d2dClaimed";
  }

  return "d2d:status.manualRejected";
};
